import React from 'react';
import { FadeIn } from './FadeIn';
import { UploadCloud, Users, FileCheck, ShieldCheck, ArrowRight } from 'lucide-react';
import { useContactModal } from './ContactModalContext';
export const HowItWorks = () => {
  const {
    openModal
  } = useContactModal();
  const steps = [{
    icon: <UploadCloud size={28} className="text-sage" data-id="element-185" />,
    title: 'Передаёте документы',
    desc: 'Менеджер согласует с вами способ передачи МРТ и описания ситуации. Это занимает около 10 минут.'
  }, {
    icon: <Users size={28} className="text-sage" data-id="element-186" />,
    title: 'Независимый анализ',
    desc: 'Два эксперта анализируют ваши документы. Они не знают друг о друге и не видят чужих выводов.'
  }, {
    icon: <FileCheck size={28} className="text-sage" data-id="element-187" />,
    title: 'Получаете заключение',
    desc: 'Через 48 часов мы присылаем структурированный отчёт, объединяющий оба экспертных мнения.'
  }, {
    icon: <ShieldCheck size={28} className="text-sage" data-id="element-188" />,
    title: 'Принимаете решение',
    desc: 'У вас есть понятная экспертная оценка. Окончательный выбор остаётся за вами и вашим лечащим врачом.'
  }];
  return <section id="how-it-works" className="py-24 bg-offwhite" data-id="element-189">
      <div className="max-w-6xl mx-auto px-6" data-id="element-190">
        <FadeIn data-id="element-191">
          <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-192">
            <h2 className="font-serif text-3xl md:text-4xl text-navy mb-6" data-id="element-193">
              Как это работает
            </h2>
            <p className="text-lg text-navyLight" data-id="element-194">
              Простой процесс, который экономит ваше время и нервы. Никаких
              поездок и очередей.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-4 gap-8 relative" data-id="element-195">
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-beige" data-id="element-196" />

          {steps.map((step, idx) => <FadeIn key={idx} delay={idx * 0.1} className="relative z-10" data-id="element-197">
              <div className="flex flex-col items-center text-center" data-id="element-198">
                <div className="w-24 h-24 rounded-full bg-white shadow-soft flex items-center justify-center mb-6 relative" data-id="element-199">
                  {step.icon}
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-navy text-white flex items-center justify-center font-serif text-sm" data-id="element-200">
                    {idx + 1}
                  </div>
                </div>
                <h3 className="text-xl font-medium text-navy mb-3" data-id="element-201">
                  {step.title}
                </h3>
                <p className="text-navyLight leading-relaxed" data-id="element-202">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-203">
          <div className="text-center mt-16" data-id="element-204">
            <button onClick={() => openModal('info')} className="text-sage font-medium hover:text-sageDark transition-colors inline-flex items-center gap-2 group" data-id="element-205">
              Узнать подробнее об услуге
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-206" />
            </button>
          </div>
        </FadeIn>
      </div>
    </section>;
};